import { doc, deleteDoc } from "firebase/firestore";
import { getDb } from "@/services/firebase/config";

const COLLECTION_NAME = "tutoriais";

class DeleteTutorial {
  execute = async (id: string): Promise<void> => {
    const db = getDb();
    const docRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(docRef);
  };
}

export { DeleteTutorial };
